import './Tag.css'

export function Tag({ selected = false, children, onClick, style, ...rest }) {
  return (
    <button
      type="button"
      className={'u-tag' + (selected ? ' u-tag--on' : '')}
      aria-pressed={selected}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Tag
